import { useEffect, useState } from 'react';
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import LivrosGrid from '../../componentes/js/LivrosGrid';
import dadosLivros from '../../dados/livros.json';

// Lista de livros guardada no próprio site (src/dados/livros.json)
const todosOsLivros = [
    ...dadosLivros.fundamental1,
    ...dadosLivros.fundamental2,
    ...dadosLivros.medio,
];

const Livros = () => {
    const livros = todosOsLivros;
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
        setIsMobile(true);
        }
    }, []);

    return (
        <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
            <Header />
            <main>
            <div className='conteudo'>
                <h2 className='titulo-secao'>Todos os Livros</h2>
                <LivrosGrid livros={livros} />
            </div>
            </main>
            <Footer />
        </div>
    );
};

export default Livros;